import { Grid2, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Backdrop, CircularProgress, } from "@mui/material";
import ControlTiempo from './control-tiempo/ControlTiempo'
const live_events_service = require('../../helpers/live_events_service')

const Home = () => {
  const [evento, setEvento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contador] = useState(0)
  useEffect(() => {
    live_events_service.getData('/evento/view-by-hash/' + process.env.REACT_APP_EVT).then((response) => {
      setEvento(response.data.response_database.result[0])
      setLoading(false)
    }).catch((error) => {
      console.log(error)
    })
  }, [contador])
  return (
    <Stack spacing={3}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <video
        autoPlay
        muted
        playsInline
        loop
        style={{
          width: "100%",
        }}
      >
        <source
          src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/1743096134.mp4"
          type="video/mp4"
        />
      </video>
      <Stack spacing={3} textAlign="justify" p={5}>
        <Typography variant="h4" textAlign="center">
          Objetivo del Congreso COPLAFT
        </Typography>
        <Typography variant="p" textAlign="center">
          Promover el intercambio de conocimientos y mejores prácticas en la
          prevención del lavado de activos y financiamiento del terrorismo en
          Latinoamérica, fortaleciendo la cooperación entre instituciones
          financieras, reguladores y expertos en cumplimiento para combatir
          eficazmente estos delitos.
        </Typography>
      </Stack>
      <Stack
        spacing={3}
        textAlign="justify"
        p={5}
        style={{ backgroundColor: "#81a4c7" }}
      >
        <Typography variant="h4" textAlign="center" style={{ color: "white" }}>
          ¿Quiénes asisten a COPLAFT?
        </Typography>
        <Grid2 container alignItems="center">
          <Grid2 size={{ xs: 12, md: 3, lg: 3 }} justifyItems="center">
            <Card
              style={{ backgroundColor: "transparent", width: "75%", justifyItems: 'center' }}

              elevation={0}
            >
              <CardMedia
                style={{ width: '50%' }}
                component="img"
                image="https://escuela-bancaria.s3.us-east-2.amazonaws.com/recursos-humanos.png"
                alt="green iguana"
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                  style={{ color: "white", textAlign: "center" }}
                >
                  + 250 Directivos y Tomadores de Decisiones
                </Typography>
                <Typography variant="body2" sx={{ color: "white", fontWeight: 'bolder', fontSize: '1.2em' }}>
                  Altos ejecutivos de bancos, entidades financieras y organismos
                  reguladores especializados en cumplimiento y gestión de
                  riesgos.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 3, lg: 3 }} justifyItems="center">
            <Card
              elevation={0}
              style={{ backgroundColor: "transparent", width: "75%", justifyItems: 'center' }}

            >
              <CardMedia
                style={{ width: '50%' }}
                component="img"
                image="https://escuela-bancaria.s3.us-east-2.amazonaws.com/banco.png"
                alt="green iguana"
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                  style={{ color: "white", textAlign: "center" }}
                >
                  + 60 Entidades Financieras
                </Typography>
                <Typography variant="body2" sx={{ color: "white", fontWeight: 'bolder', fontSize: '1.2em' }}>
                  Bancos, aseguradoras, casas de bolsa y otras empresas del
                  sector financiero comprometidas con la prevención del lavado
                  de activos y el financiamiento del terrorismo.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 3, lg: 3 }} justifyItems="center">
            <Card
              elevation={0}
              style={{ backgroundColor: "transparent", width: "75%", justifyItems: 'center' }}

            >
              <CardMedia
                style={{ width: '50%' }}
                component="img"
                image="https://escuela-bancaria.s3.us-east-2.amazonaws.com/seminario.png"
                alt="green iguana"
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                  style={{ color: "white", textAlign: "center" }}
                >
                  + 14 conferencistas expertos{" "}
                </Typography>
                <Typography variant="body2" sx={{ color: "white", fontWeight: 'bolder', fontSize: '1.2em' }}>
                  Especialistas en cumplimiento normativo, regulación financiera
                  y gestión de riesgos provenientes de América Latina, Estados
                  Unidos y Europa.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 3, lg: 3 }} justifyItems="center">
            <Card
              elevation={0}
              style={{ backgroundColor: "transparent", width: "75%", justifyItems: 'center' }}

            >
              <CardMedia
                style={{ width: '50%' }}
                component="img"
                image="https://escuela-bancaria.s3.us-east-2.amazonaws.com/america-del-sur.png"
                alt="green iguana"
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                  style={{ color: "white", textAlign: "center" }}
                >
                  + 17 Países de América Latina{" "}
                </Typography>
                <Typography variant="body2" sx={{ color: "white", fontWeight: 'bolder', fontSize: '1.2em' }}>
                  Representantes de organismos supervisores, unidades de
                  inteligencia financiera y empresas del sector financiero de
                  toda la región.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
        </Grid2>
      </Stack>
      <ControlTiempo tiempo={25} targetDate='2025-09-22 07:00:00' />

      <Stack style={{ backgroundColor: "#81a4c7" }} spacing={5} pt={5} pb={5}>
        <Typography
          variant="h4"
          style={{ textAlign: "center", color: "white" }}
        >
          ¡Visita Guatemala!
        </Typography>
        <iframe
          width="100%"
          height="600px"
          src="https://www.youtube-nocookie.com/embed/vCccxVvXrTk?si=ebqIdh3i4l9FLJwf"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </Stack>

    </Stack>
  );
};

export default Home;

/*

LinkedInIcon
FacebookIcon
XIcon
InstagramIcon
YouTubeIcon
*/

///https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+FELABAN+blanco.png

//https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+ABG+blanco.png
